export const problematicDeptCertificatesFilters = ({ chambers }) => {
  return [
    {
      control: "autocomplete",
      label: "Κατάσταση",
      name: "status",
      options: [
        { key: "Σε Αναμονή", value: 0 },
        { key: "Μη Επιβεβαιωμενο", value: 1 },
        { key: "Μη Εξοφλημένο", value: 2 },
        { key: "Εξοφλημένο", value: 3 },
        { key: "Μη Τερματικό Σφάλμα", value: 4 },
        { key: "Τερματικό Σφάλμα", value: 5 },
        { key: "Μη έγκυρος ΑΦΜ", value: 6 },
      ],
    },
    {
      control: "autocomplete",
      label: "Επιμελητήριο",
      name: "chamberId",
      options: [
        ...chambers.map((chamber) => ({
          key: chamber.label,
          value: chamber.id,
        })),
      ],
    },
    {
      control: "select",
      label: "Έτος",
      name: "year",
      options: [
        {
          key: "Όλα",
          value: 0,
        },
        {
          key: "2018",
          value: 2018,
        },
        {
          key: "2019",
          value: 2019,
        },
        {
          key: "2020",
          value: 2020,
        },
      ],
    },
  ];
};
